import React from 'react';
import { StateEnum } from 'constants/state';
import { FormInstance } from 'antd';
import {
  Input,
  Select,
} from 'UI';

import {
  FormContainer,
  BaseFormItem,
  AddressInline,
  NotesInline,
  InlineFormGroup,
} from './style';

export interface UpdateLocationFormData {
  name?: string
  state?: StateEnum
  city?: string
  address?: string
  phone?: string
  email?: string
  cpf?: string
  cnpj?: string
  stateRegistration?: string
  notes?: string
  isActive?: boolean
}

interface UpdateLocationFormProps {
  formHandler: FormInstance
  data: UpdateLocationFormData
  onDataChange(changedValue: unknown, formData: unknown): void
  isLoading?: boolean
}

const UpdateLocationForm = ({
  formHandler,
  isLoading,
  data,
  onDataChange,
}: UpdateLocationFormProps): JSX.Element => (
  <FormContainer
    layout="vertical"
    form={formHandler}
    requiredMark={false}
    initialValues={data}
    onValuesChange={onDataChange}
  >
    <BaseFormItem
      label="Encarregado"
      name="maintainer"
      rules={[
        {
          required: true,
          message: 'Insira um encarregado',
        },
      ]}
    >
      <Input disabled={isLoading} />
    </BaseFormItem>
    <BaseFormItem
      label="Fazenda"
      name="name"
      rules={[
        {
          required: true,
          message: 'Insira um nome',
        },
      ]}
    >
      <Input disabled={isLoading} />
    </BaseFormItem>
    <AddressInline>
      <BaseFormItem
        label="Cidade"
        name="city"
        className="city-input"
      >
        <Input disabled={isLoading} />
      </BaseFormItem>
      <BaseFormItem
        label="Estado"
        name="state"
        className="state-input"
      >
        <Select disabled={isLoading}>
          {Object.values(StateEnum).map((state) => (
            <Select.Option value={state} key={state}>{state}</Select.Option>
          ))}
        </Select>
      </BaseFormItem>
    </AddressInline>
    <BaseFormItem
      label="Telefone"
      name="phone"
    >
      <Input disabled={isLoading} />
    </BaseFormItem>
    <InlineFormGroup>
      <BaseFormItem
        label="CPF"
        name="cpf"
        className="cpf-input"
      >
        <Input disabled={isLoading} />
      </BaseFormItem>
      <BaseFormItem
        label="CNPJ"
        name="cnpj"
        className="cnpj-input"
      >
        <Input disabled={isLoading} />
      </BaseFormItem>
    </InlineFormGroup>
    <BaseFormItem
      label="Inscrição estadual"
      name="stateRegistration"
    >
      <Input disabled={isLoading} />
    </BaseFormItem>
    <NotesInline
      label="Observações"
      name="notes"
    >
      <Input.TextArea rows={5} />
    </NotesInline>
  </FormContainer>
);

UpdateLocationForm.defaultProps = {
  isLoading: false,
};

export default UpdateLocationForm;
